import React from 'react'
import intl from 'react-intl-universal'
import { IWebsite } from './CanonicalUrl'
import RegenErrorCode from './RegenErrorCode'

interface RegenerateInputProps {
  website: IWebsite
  canonical_website: string
  parentRegenerating: boolean
  handleSingleRegeneration?: (id: string) => Promise<void>
  hasRegeneratePermissions: boolean
  isDirty?: boolean
  isPublished?: boolean
  isScheduled?: boolean
}

const TOO_MANY_REQUEST = 429
const SERVER_ERROR = 500

export default function RegenerateInput({
  website,
  canonical_website,
  parentRegenerating,
  handleSingleRegeneration,
  hasRegeneratePermissions,
  isDirty,
  isPublished,
  isScheduled,
}: RegenerateInputProps) {
  return (
    <div
      key={website.id}
      className="mb-3 canonical-url--input"
      data-testid="canonical-url--input"
    >
      <label className="mr-2">{website.id}</label>
      {canonical_website === website.id && (
        <span
          className="badge badge-primary"
          data-testid="primary-website-badge"
        >
          {intl.get('canonicalUrl.websiteUrl.badge')}
        </span>
      )}

      <div className="canonical-url--inputs">
        <div className="canonical-url--inputs-input">
          <input
            type="text"
            value={website.website.website_url}
            className="form-control col"
            data-testid="website-url-input"
            readOnly
          />
        </div>
        <div className="canonical-url--inputs-button">
          <button
            id={`${website.id}-regen-button`}
            className={
              !parentRegenerating
                ? 'btn col-auto btn-outline-primary'
                : 'btn col-auto btn-is-regenerating'
            }
            type="button"
            onClick={() => handleSingleRegeneration?.(website.id)}
            disabled={
              (parentRegenerating ||
                !hasRegeneratePermissions ||
                !isPublished) &&
              !isScheduled
            }
          >
            {intl.get('canonicalUrl.websiteUrl.button')}
          </button>
        </div>
        <div className="canonical-url--inputs-status-icon">
          {website.website?.success === true &&
            !parentRegenerating &&
            isDirty && (
              <i
                className="fa fa-check-circle"
                aria-hidden="true"
                data-testid="url-regeneration-success-icon"
              ></i>
            )}
          {!website.website?.success && !parentRegenerating && isDirty && (
            <i
              className="fa fa-times-circle"
              aria-hidden="true"
              data-testid="url-regeneration-error-icon"
            ></i>
          )}
        </div>
      </div>

      {website.website.success === false &&
        website.website.errorCode &&
        website.website.errorCode !== TOO_MANY_REQUEST &&
        website.website.errorCode !== SERVER_ERROR && (
          <div className="canonical-url--input-error-message">
            <i className="fa fa-times-circle" aria-hidden="true"></i>
            <RegenErrorCode errorCode={website.website.errorCode} />
          </div>
        )}
    </div>
  )
}
